"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmModal = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var components_1 = require("components");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
require("./index.scss");
var ConfirmModal = function (props) {
    var _a, _b;
    return (React.createElement(components_1.ConfirmDialog, { className: 'reports-confirmation-modal', isOpen: props.isOpen, close: props.onClose, header: props.title, body: React.createElement(React.Fragment, null,
            React.createElement(ConfirmDialog_1.Exclamation, null),
            React.createElement("div", { className: 'text' },
                React.createElement("h2", { className: 'title' }, (_a = props.subTitle) !== null && _a !== void 0 ? _a : (0, translation_1.getLocalization)('genericWarningConfirmationModal/pleaseConfirm')),
                React.createElement("div", null, ((_b = props.content) !== null && _b !== void 0 ? _b : []).map(function (content, i) { return (React.createElement("p", { key: i }, content)); })))), footer: React.createElement(React.Fragment, null,
            props.confirmationPending && (React.createElement("div", { key: 'loading', className: 'loading' },
                React.createElement(sok_ui_1.LoadingSpinner, null))),
            React.createElement(sok_ui_1.Button, { color: 'red', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/confirm'), onClick: props.onConfirm, disabled: props.confirmationPending }),
            React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/cancel'), onClick: props.onClose })) }));
};
exports.ConfirmModal = ConfirmModal;
